/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Input, Select, DatePicker, Button, message } from 'antd';
import { useForm } from 'antd/es/form/Form';
import PhoneInput, { parsePhoneNumber, PhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { durationOptions, generateTimeSlots } from '../../constants';
import { useAppStore } from '../../store/appStore';
import { useAgenda } from '../../hooks/useAgenda';
import {  useApproveMeeting } from '../../hooks/useMeetings';

const timeSlots = generateTimeSlots();

export interface MeetingRequestData {
  id: number;
  plantId: string;
  organisation: string;
  title: string;
  preferredDate: string;
  preferredTime: string;
  additionalNotes: string;
  requestStatus: string;
  requestorId: number;
  agendaId?: number;
  subAgendaId?: number;
  setDuration?: any;
  requestor: {
    id: number;
    requesterName: string;
    requesterEmail: string;
    requesterPhone: string;
    requesterDesignation: string;
  };
  plant: {
    id: string;
    name: string;
    location: string;
    description: string;
  };
  meetingRequestAttendees: Array<{
    id: number;
    attendee: {
      id: number;
      name: string;
      email: string;
      designation: string;
    };
  }>;
  meetingRequestExternalUsers: Array<{
    id: number;
    name: string;
    email: string;
    designation: string;
  }>;
}

interface FormValues {
  organisation: string;
  title: string;
  meetingDate: dayjs.Dayjs;
  meetingTime: string;
  additionalNotes: string;
  requesterName: string;
  requesterEmail: string;
  requesterPhone: string;
  setDuration: number;
  agendaId?: number;
  subAgendaId?: number;
  assignedUserIds: string[];
  requesterDesignation: string;
  presenter: string[];
  admin: string[];
  attendees: Array<{
    fullName: string;
    email: string;
    department: string;
  }>;
  externalUsers: Array<{
    fullName: string;
    email: string;
    position: string;
      department: string;
  }>;
}

interface EditMeetingModalProps {
  meetingData: MeetingRequestData;
  onUpdate: (values: FormValues, id: string) => void;
  closeStatusModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const ScheduleMeeting: React.FC<EditMeetingModalProps> = ({
  closeStatusModal,
  meetingData,
  onUpdate,
  //   setMeetingURL,
}) => {
  const [form] = useForm<FormValues>();
  const profile = useAppStore((state) => state.profile);
  console.log(meetingData, 'meetingdata');
  //All users

  const hosts = useAppStore((state) => state.hosts);
  const arManagers = useAppStore((state) => state.arManagers);

  const profilecheck = useAppStore((state) => state.profile);

const roleName = profilecheck?.user?.role?.roleName;
const isMarketingManager = roleName === "Marketing Manager";
const isMeetingManager = roleName === "Meeting Manager";

  const [phone, setPhone] = useState<PhoneNumber | undefined>();
  const { mutate: approveMeeting, isPending: isApprovePending } = useApproveMeeting();

  console.log("meeting data aaaaa",meetingData)

  useEffect(() => {
    if (meetingData) {
      // Combine attendees from both sources
      const allAttendees = [
        ...meetingData.meetingRequestAttendees.map((item) => ({
          fullName: item.attendee.name,
          email: item.attendee.email,
          department: item.attendee.designation,
        })),
        ...meetingData.meetingRequestExternalUsers.map((user) => ({
          fullName: user.name,
          email: user.email,
          department: user.designation,
        })),
      ];

      // Set form values
      form.setFieldsValue({
        organisation: meetingData.organisation,
        title: meetingData.title,
        meetingDate: dayjs(meetingData.preferredDate),
        meetingTime: meetingData.preferredTime,
        additionalNotes: meetingData.additionalNotes,
        agendaId: meetingData.agendaId,
        subAgendaId: meetingData.subAgendaId,
          setDuration: meetingData.setDuration ?? 120, // ✅ FIX
        requesterName: meetingData.requestor.requesterName,
        requesterEmail: meetingData.requestor.requesterEmail,
        requesterDesignation: meetingData.requestor.requesterDesignation,
        attendees: allAttendees,
        requesterPhone: meetingData.requestor.requesterPhone,
      });

      // Parse and set phone number
      const parsedPhone = parsePhoneNumber(meetingData.requestor.requesterPhone || '');
      setPhone(parsedPhone);
    }
  }, [meetingData, form]);

  const handleSubmit = async (values: FormValues) => {
    const payload = {
      ...values,
      meetingDate: values.meetingDate.format('YYYY-MM-DD'),
      id: meetingData.id,
      requesterPhone: values.requesterPhone,
    };

    const payloadData = {
      title: payload.title,
      meetingDate: payload.meetingDate,
      meetingTime: payload.meetingTime,
      additionalNotes: payload.additionalNotes,
      setDuration: payload.setDuration,
      agendaId: payload.agendaId,
      subAgendaId: payload.subAgendaId,
      attendees: payload.attendees,
      externalUsers:
        payload.assignedUserIds?.map((email: string) => ({
          fullName: 'name',
          email: email,
          position: 'department',
        })) || [],
      // ts-ignore
      assignedUserIds: [...payload.presenter, ...payload.admin],
      sendEmail: true,
      createdBy: profile?.user.id,
    } as import('../../types/meeting').ApproveMeetingPayload;

    approveMeeting(
      { id: meetingData.id, payload: payloadData },
      {
        onSuccess: () => {
          // @ts-expect-error onUpdate expects string id in parent typing
          onUpdate(payloadData, meetingData.id);
          closeStatusModal(false);
          message.success('Meeting scheduled successfully');
        },
        onError: (error: Error) => {
          message.error(`Failed to schedule meeting: ${error.message}`);
        },
      }
    );
  };

  const { data: agenda } = useAgenda();
  const selectedAgendaId = Form.useWatch('agendaId', form);
  const subAgendaOptions =
    (agenda || []).find((a: any) => a.agendaId === selectedAgendaId)?.subAgendas || [];

  // const { mutate: rejectMeeting } = useRejectMeeting();
  // const handleCancel = () => {
  //   closeStatusModal(false);
  //   rejectMeeting(meetingData.id, {
  //     onSuccess: () => {
  //       // Reset form and state only after successful rejection
  //       form.resetFields();
  //       setPhone(undefined);
  //       message.success('Meeting rejected successfully');
  //     },
  //     onError: (error: Error) => {
  //       message.error(`Failed to reject meeting: ${error.message}`);
  //     },
  //   });
  // };

  return (
    <Form form={form} layout="vertical" onFinish={handleSubmit} className="mt-4">
      {/* Plant Information (Read-only) */}
      <div className="bg-gray-50 !p-4 rounded-lg !mb-4">
        <h3 className="text-lg font-semibold mb-2">Plant Information</h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Plant Name</label>
            {/* <div className="mt-1 text-sm text-gray-900">{meetingData?.plant?.name}</div> */}
            <div className="mt-1 text-sm text-gray-900">kosamba</div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Location</label>
            {/* <div className="mt-1 text-sm text-gray-900">{meetingData?.plant?.location}</div> */}
            <div className="mt-1 text-sm text-gray-900">kosamba, Gujarat</div>
          </div>
        </div>
      </div>

      {/* Meeting Information */}
      <div className="">
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: 'Please enter title' }]}
        >
          <Input placeholder="Title" disabled/>
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item
          label="Date"
          name="meetingDate"
          rules={[{ required: true, message: 'Please select a date' }]}
        >
          <DatePicker className="w-full" disabled />
        </Form.Item>

        <Form.Item
          label="Time"
          name="meetingTime"
          rules={[{ required: true, message: 'Please select time' }]}
        >
          <Select placeholder="Select time" disabled>
            {timeSlots.map((time) => (
              <Select.Option key={time.value} value={time.value}>
                {time.key}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item
          label="Agenda"
          name="agendaId"
          rules={[{ required: true, message: 'Please select an agenda' }]}
        >
          <Select
            placeholder="Select agenda"
            onChange={() => {
              form.setFieldsValue({ subAgendaId: undefined });
            }}
            disabled
          >
            {(agenda || []).map((ag: any) => (
              <Select.Option key={ag.agendaId} value={ag.agendaId}>
                {ag.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Sub Agenda"
          name="subAgendaId"
          rules={[{ required: false, message: 'Please select a sub agenda' }]}
        >
          {/* <Select placeholder="Select sub agenda" disabled={!selectedAgendaId}>  */}
            <Select placeholder="Select sub agenda" disabled={isMarketingManager}>
            {subAgendaOptions.map((s: any) => (
              <Select.Option key={s.subAgendaId} value={s.subAgendaId}>
                {s.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>

      <Form.Item
        label="Duration"
        name="setDuration"
        // rules={[{ required: true, message: 'Please select duration' }]}
        className="mb-2"
      >
        <Select placeholder="Select duration" disabled={isMarketingManager}>
          {durationOptions.map((opt) => (
            <Select.Option key={opt.value} value={opt.value}>
              {opt.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Additional Notes" name="additionalNotes">
        <Input.TextArea rows={3} placeholder="Additional notes (optional)"  disabled={isMarketingManager}/>
      </Form.Item>

      <Form.Item
        label="PGP Users"
        name="assignedUserIds"
        className="flex-1"
        rules={[
          {
            validator: (_, value) => {
              if (!value || value.length === 0) return Promise.resolve();
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              const invalid = (value as string[]).filter((v) => !emailRegex.test(v));
              return invalid.length
                ? Promise.reject(new Error(`Invalid emails: ${invalid.join(', ')}`))
                : Promise.resolve();
            },
          },
        ]}
      >
        <Select
          mode="tags"
          open={false}
          placeholder="Type email and press Enter (or comma)"
          tokenSeparators={[',', ' ']}
          className="w-full"
          disabled={isMarketingManager}
        />
      </Form.Item>

      <div className="flex gap-4">
        <Form.Item
          label="Presenter"
          name="presenter"
          rules={[
            {
              required: true,
              validator: (_, value) => {
                if (!value || value.length < 1)
                  return Promise.reject(new Error('Please add at least one presenter'));
                if (value.length > 8)
                  return Promise.reject(new Error('You can add a maximum of 8 presenters'));
                return Promise.resolve();
              },
            },
          ]}
          className="flex-1"
        >
          <Select mode="multiple" placeholder=" Please select a presenter" className="w-full" disabled={isMarketingManager}>
            {arManagers.map((presenter) => (
              <Select.Option key={presenter.id} value={presenter.id}>
                {presenter.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Meeting Managers"
          name="admin"
          rules={[
            {
              required: true,
              validator: (_, value) => {
                if (!value || value.length < 1)
                  return Promise.reject(new Error('Please add at least one admin'));
                if (value.length > 5)
                  return Promise.reject(new Error('You can add a maximum of 5 meeting managers'));
                return Promise.resolve();
              },
            },
          ]}
          className="flex-1"
        >
          <Select mode="multiple" placeholder="Please select an admin" className="w-full" disabled={isMarketingManager}>
            {hosts.map((admin) => (
              <Select.Option key={admin.id} value={admin.id}>
                {admin.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>

      {/* Requestor Information */}
      <div className="border-t !pt-4 !mt-4">
        <h3 className="text-lg font-semibold mb-4">Requestor Information</h3>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            label="Name"
            name="requesterName"
            rules={[{ required: true, message: 'Please enter name' }]}
          >
            <Input placeholder="Name" disabled />
          </Form.Item>

          <Form.Item
            label="Email"
            name="requesterEmail"
            rules={[
              { required: true, message: 'Please enter email' },
              { type: 'email', message: 'Invalid email' },
            ]}
          >
            <Input placeholder="Email" disabled />
          </Form.Item>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            label="Phone Number"
            name="requesterPhone"
            rules={[{ required: true, message: 'Please enter phone number' }]}
          >
            <PhoneInput
              international
              defaultCountry={phone?.country || 'IN'}
              value={phone?.number || ''}
              onChange={(val) => {
                const parsed = parsePhoneNumber(val || '');
                setPhone(parsed);
                form.setFieldsValue({ requesterPhone: val });
              }}
              placeholder="Enter phone number"
              className="custom-phone-input cursor-not-allowed bg-[#f5f4f4]"
              disabled
            />
          </Form.Item>

          <Form.Item
            label="Organisation"
            name="organisation"
            rules={[{ required: true, message: 'Please enter organisation' }]}
          >
            <Input placeholder="Organisation" disabled />
          </Form.Item>
        </div>
      </div>

      {/* Attendees */}
      <div className="border-t !pt-4 !mt-4">
        <Form.List name="attendees">
          {(fields, { add, remove }) => (
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold">Requested Attendees</h3>
                <Button type="dashed" onClick={() => add()} disabled>
                  + Add Attendee
                </Button>
              </div>

              {fields.map(({ key, name, ...restField }) => (
                <div key={key} className="grid grid-cols-4 gap-4 items-start">
                  <Form.Item
                    {...restField}
                    name={[name, 'fullName']}
                    rules={[{ required: true, message: 'Enter name' }]}
                  >
                    <Input placeholder="Name" disabled />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, 'email']}
                    rules={[
                      { required: true, message: 'Enter email' },
                      { type: 'email', message: 'Invalid email' },
                    ]}
                  >
                    <Input placeholder="Email" disabled/>
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, 'department']}
                    rules={[{ required: true, message: 'Enter designation' }]}
                  >
                    <Input placeholder="Designation" disabled />
                  </Form.Item>

                  <Button type="link" danger onClick={() => remove(name)} className="mt-1" disabled>
                    Remove
                  </Button>
                </div>
              ))}
            </div>
          )}
        </Form.List>
      </div>

      {/* Form Actions */}
      {/* <div className="flex justify-end gap-2 !mt-6 !pt-4 border-t"> */}
        {/* <Button onClick={handleCancel} disabled={isRejectPending}>
          Reject
        </Button> */}
        {/* <Button type="primary" htmlType="submit" loading={isApprovePending}>
          Schedule
        </Button> */}
      {/* </div> */}
      <div className="flex justify-end gap-2 !mt-6 !pt-4 border-t">
  {isMarketingManager ? (
    <Button onClick={() => closeStatusModal(false)}>
      Cancel
    </Button>
  ) : (
    // <Button type="primary" htmlType="submit" loading={isApprovePending}>
    //   Schedule
    // </Button>
      <Button type="primary" htmlType="submit" loading={isApprovePending}>
      {isMeetingManager ? 'Add' : 'Schedule'}
    </Button>
  )}
</div>

    </Form>
  );
};

export default ScheduleMeeting;
